import SectionProvider from '@builder/sections/SectionProvider'

export const name = 'Post Categories'
export const group = 'Dynamic Post Template'
export const beta = false

export const defaultOptions = {
  content: {
    data: {
      type: 'blog-post-categories-mod'
    }
  }
}

export const icon = ''

export default class ElPostCategories extends SectionProvider {
  constructor (options = {}) {
    super('ElPostCategories', options)

    this.name = name
    this.group = group
    this.defaultOptions = defaultOptions
  }
}
